module.exports = __webpack_public_path__ + "static/media/Kiara Satchell Headshot.ecf50975.png";